import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../service/services'
import swal from 'sweetalert2'
import numeral from 'numeral'
import AnimatedNumber from "animated-number-vue";
import $ from "jquery";

export default {
  data() {
    return {
      payload: '',
      item_cart: [],
      method: 'credit',
      // css
      menu: 'menu1',
      menu_page: '',
      items_page: '',
      //
      result_count: 0,
      activeItem:1,
      current_page: 0,
      menu_perpage: 5,
      activeMenu: 1,
      items: [],
      // call api
      obj_menus: [],
      obj_items: [],
      obj_menusv2: [],
      obj_itemsv2: [],
      active: 'home',
      // item pagination
      result_count_item: 0,
      current_page_item: 0,
      menu_perpage_item: 16,
      activeItem_item: 1,
      //
      id_item: '',
      count_item: 1,
      item_number: 1,
      member_type: 0,
      stage_modal: false
    }
  },
  components: {
    Loading,
    AnimatedNumber
  },
  computed: {
    ...mapState(['isLoading', 'lang', 'SaleID', 'SaleType', 'PaymentType', 'accessToken', 'AmountPayment', 'reponseStatus', 'sale_info','scan_barcode','StatusQrcode','page_status','sale_subs_slip']),
    ...mapMutations(['onMessageWs']),
    menu_paginate() {
      this.result_count = this.obj_menus.length
      if (this.current_page >= this.totalPages) {
        this.current_page = Math.max(0, this.totalPages - 1)
      }
      var index = this.current_page * this.menu_perpage
      return this.obj_menus.slice(index, index + this.menu_perpage)
    },
    totalPages() {
      console.log("this.result_count",Math.ceil(this.result_count / this.menu_perpage))
      // return Math.ceil(this.result_count / this.menu_perpage)
      return Math.ceil(this.result_count / this.menu_perpage)
    },
    item_paginate() {
      if (this.obj_items === null) {
        alert("ไม่มีสินค้า")
        this.$router.push('/')
        return
      }
      this.result_count_item = this.obj_items.length
      if (this.current_page_item >= this.totalPages1) {
        this.current_page_item = Math.max(0, this.totalPages1 - 1)
      }
      var index = this.current_page_item * this.menu_perpage_item
      return this.obj_items.slice(index, index + this.menu_perpage_item)
    },
    item_totalPages() {
      return Math.ceil(this.result_count_item / this.menu_perpage_item)
    },
    totalprice() {
      // console(this.credit_limitD)
      return this.item_cart.reduce(function (sum, item) {
        return (sum + item.price)
      }, 0)
    },
  },
  methods: {
    formatToPrice(value) {
      var money = numeral(value).format('0,0');
      return money
    },
    buy_item(obj) {
      this.count_item = 1
      this.Soundclick();
      this.items = obj
      this.sayLang(obj.name)
      console.log(this.items)
    },
    count_item_add() {
      this.Soundclick();
      this.count_item++
    },
    count_item_remove() {
      this.Soundclick();
      if (this.count_item <= 1) {
        return
      }
      this.count_item--
    },
    up_item() {
      document.getElementById('containitem').scrollTop -= 280
      this.Soundclick();
    },
    down_item() {
      document.getElementById('containitem').scrollTop += 280
      this.Soundclick();
    },
    cancel_item() {
      this.Soundclick();
      swal.fire({
        title: 'ยกเลิก',
        text: "ท่านต้องการยกเลิกสินค้าทั้งหมด",
        type: 'error',
        animation: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK !'
      }).then((result) => {
        if (result.value) {
          this.item_cart = []
        }
      })
    },
    payment_item(item) {
      console.log(item)
      let index = this.item_cart.findIndex(val => val.id === item.id);
      if (index != -1) {
        this.item_cart[index].price += this.count_item * item.price
        this.item_cart[index].qty += this.count_item
        console.log(this.item_cart)
        return
      }


      console.log(item)
      this.Soundclick();
      var payload = {
        id: item.id,
        image: item.image,
        bar_code: item.bar_code,
        price_slip: item.price,
        item_id: item.item_id,
        name: item.name,
        qty: this.count_item,
        price: this.count_item * item.price,
        price_1: item.price_1,
        price_2: item.price_2
      }
      //  this.items.splice(this.randomIndex(), 0, this.nextNum++)
      this.item_cart.unshift(payload)
    },
    removeitem(id,v) {
      this.Soundclick();
      console.log(id,v)
      // swal
      // .fire({
      //   title: 'ยกเลิก',
      //   text: `ท่านต้องการลบสินค้า ${v.name} ออกจากตะกร้าสินค้า ?`,
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'ตกลง',
      //   cancelButtonText: 'ยกเลิก'
      // })
      // .then(result => {
      //   if (result.value) {
          this.item_cart.splice(id, 1);
      //   } else {

      //   }
      // })

    },
    back_menu() {
      this.menu_page = 'page1'
      this.Soundclick();
      if (this.current_page > 0) {
        this.current_page--
        this.activeItem--
      }
      console.log("totalPages",this.totalPages)
      console.log("activeItem",this.activeItem)
      console.log("current_page",this.current_page)
    },
    next_menu() {
      this.menu_page = 'page2'
      this.Soundclick();
      if (this.activeItem < this.totalPages) {
        this.current_page++
        this.activeItem++
      }
      console.log("totalPages",this.totalPages)
      console.log("activeItem",this.activeItem)
      console.log("current_page",this.current_page)
    },
    back_item() {
      this.items_page = 'page1'
      this.Soundclick();
      if (this.current_page_item > 0) {
        this.current_page_item--
        this.activeItem_item--
      }
      console.log("this.current_page_item",this.current_page_item)
      console.log("this.activeItem_item1",this.activeItem_item)
    },
    next_item() {
      this.items_page = 'page2'
      this.Soundclick();
      if (this.activeItem_item < this.item_totalPages) {
        this.current_page_item++
        this.activeItem_item++
      }
      console.log("this.current_page_item",this.current_page_item)
      console.log("this.activeItem_item",this.activeItem_item)
      console.log("this.item_totalPages",this.item_totalPages)
    },
    more_menu() {
      this.Soundclick();
    },
    choosemenu(val) {
      console.log(val)
      this.Soundclick();
      this.menu = val
      this.id_item = val.id
      this.callitem_shop()
    },
    choosemethod(val) {
      this.Soundclick();
      this.method = val
    },
    back() {
      this.Soundclick();
      this.$router.push({
        name: 'Main'
      })
      clearInterval(this.$store.state.scan_barcode)
    },
    init_menus() {
      this.$store.state.isLoading = true
      const header = {
        headers: {
          "x-access-token": this.accessToken
        }
      }
      const body = {
        // member: this.$store.state.memberType
        // member: 1
        member: this.member_type
      }
      console.log(header)
      api.callmenus_shop_v2(
        header,
        body,
        result => {
          this.$store.state.isLoading = false
          console.log(result)
          if (result.response == "success") {
            console.log(result.data[0])
            if (this.lang == 0) {
              this.obj_menus = result.data[1].category
              this.obj_items = result.data[1].category[0].items
            } else if (this.lang == 1) {
              // this.obj_menus = result.data[0].menus
              // this.id_item = result.data[0].menus[0].id
              // this.callitem_shop()
              this.obj_menus = result.data[0].category
              this.obj_item = result.data[0].category[0].items
              this.callitem_shop()
            } else if (this.lang == 2) {
              this.obj_menus = result.data[2].category
              this.obj_items = result.data[2].category[0].items
            }
            this.activeMenu = this.obj_menus[0].cat_id
            // console.log(result.data[0].category[0].items)
            // console.log("menu " + JSON.stringify(this.obj_menus))
            // console.log("menu " + JSON.stringify(this.obj_itemsv2))
          } else {
            alert("error")
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    callitem_shop() {
      this.$store.state.isLoading = true
      const header = {
        headers: {
          "x-access-token": this.accessToken
        }
      }

      const body = {
        // member: this.$store.state.memberType
        member: this.member_type
      }

      api.callitem_shop(header, body,
        result => {
          this.$store.state.isLoading = false
          console.log(result)
          if (this.lang == 0) {
            this.obj_items = result.data[1].items
          } else if (this.lang == 1) {
            this.obj_items = result.data[0].items
          } else if (this.lang == 2) {
            this.obj_items = result.data[2].items
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      );
    },
    convertprice(val) {
      var money = numeral(val).format('0,0');
      return money
    },
    payment_final() {
      console.log(this.item_cart)
      if(this.item_cart.length < 1){
        swal.fire({
          title: 'Payment',
          text: "ไม่มีสินค้าในตะกร้า",
          type: 'warning',
          animation: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK !'
        })
        return
      }
      this.$store.state.page_status = 2
      console.log('items = ' + this.item_cart)

          let payload = []
          var total = 0
          let itemsub = []
          for (let index = 0; index < this.item_cart.length; index++) {
            var data = {
              line: index + 1,
              item_id: this.item_cart[index].id.toString(),
              item_name: this.item_cart[index].name,
              qty: this.item_cart[index].qty,
              // price_id: 1,
              // price_name: obj.item_name,
              price: parseFloat(this.item_cart[index].price),
              currency: "THB",
              image: this.item_cart[index].image
            }
            var dataslip = {
              line: index + 1,
              item_id: parseInt(this.item_cart[index].id.toString()),
              item_name: this.item_cart[index].name,
              qty: this.item_cart[index].qty,
              price_id: 1,
              price_name: '',
              price: parseFloat(this.item_cart[index].price_slip),
              unit: ''
            }
            total += parseFloat(this.item_cart[index].price)
            payload.push(data)
            itemsub.push(dataslip)
          }
          console.log(payload)
          this.$store.state.total = total
          this.$store.state.sale_subs = payload
          this.$store.state.sale_subs_slip = itemsub
          console.log(JSON.stringify(this.$store.state.sale_subs))
          console.log("this.$store.state.total :", this.$store.state.total)
          console.log("this.$store.state.sale_subs_slip :", this.$store.state.sale_subs_slip)
          this.$router.push({
            name: "Type"
          })
          clearInterval(this.$store.state.scan_barcode)
    },
    test () {

    },
    AddItemByBarcode (itemcode) {
      const header = {
        headers: {
          "x-access-token": this.accessToken
        }
      }
      const body = {
        code: itemcode
      }
      console.log("x-access-token:",header)
      console.log("playload:",body)
      api.scanByBarcode(
        body,
        header,
        result => {
          console.log("resule:",result)
          if (result.response == "success"){
            this.count_item = 1
            this.items = result.data
            this.sayLang(result.data.name)
            console.log(this.items)
            this.payment_item(this.items)
            this.$store.state.StatusQrcode = ''
          } else {
            swal.fire({
              title: 'ไม่พบสินค้า',
              type: 'error',
              animation: true,
              showConfirmButton: false,
              // showCancelButton: false,
              // confirmButtonColor: '#3085d6',
              // confirmButtonText: 'ทำรายการต่อ !',
              timer: 1500
            })
            this.$store.state.StatusQrcode = ''
          }
        },
        error => {
          alert(error)
          return
        }
      )
    },
    startsp () {
      console.log("scan_barcode")
      this.$store.state.scan_barcode = setInterval(() => {
        // console.log("Ready")
        if (this.$store.state.StatusQrcode) {
          if (this.stage_modal) {
            this.authMember(this.$store.state.StatusQrcode)
          } else {
            this.checkitemsub(this.$store.state.StatusQrcode)
          }
          // console.log("log1")
          // var testbarcode = "1000085"
          // this.AddItemByBarcode(testbarcode);
        }
      }, 1000);
    },
    checkitemsub (barcode) {
      console.log(barcode)
      console.log(this.item_cart)
      if (this.item_cart.length == 0) {
        this.AddItemByBarcode(this.$store.state.StatusQrcode);
        return
      } else {
        for (var i = 0; i <= this.item_cart.length; i++) {
          if (barcode == this.item_cart[i].bar_code) {
            this.count_item = 1
            this.items.id = this.item_cart[i].id
            this.items.image = this.item_cart[i].image
            this.items.name = this.item_cart[i].name
            this.items.price = this.item_cart[i].price / this.item_cart[i].qty
            console.log(this.items)
            this.sayLang(this.item_cart[i].name)
            this.payment_item(this.items)
            this.$store.state.StatusQrcode = ''
            break
          } else {
            this.AddItemByBarcode(this.$store.state.StatusQrcode);
            break
          }
        }
      }
    },
    menucall() {
      this.$store.state.isLoading = true
      const header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": "56819d086ae74798984b5b186a081234"
        }
      };
      const body = {
        // member: this.$store.state.memberType
        member: this.member_type
      }
      api.callmenus_shop_v2(
        header,
        body,
        result => {
          this.$store.state.isLoading = false
          console.log(result)
          if (result.response == "success") {

            console.log(result.data[0])
            if (this.lang == 0) {
              this.obj_menusv2 = result.data[1].category
              this.obj_items = result.data[1].category[0].items
            } else if (this.lang == 1) {
              this.obj_menusv2 = result.data[0].category
              this.obj_items = result.data[0].category[0].items
            } else if (this.lang == 2) {
              this.obj_menusv2 = result.data[2].category
              this.obj_items = result.data[2].category[0].items
            }
            // this.activeMenu = this.obj_menus[0].id
            // console.log(result.data[0].category[0].items)
            console.log(result.data[0].category[0].items)
            console.log("menu " + JSON.stringify(this.obj_menusv2))
            // console.log("menu " + JSON.stringify(this.obj_itemsv2))
          } else {
            alert("error")
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    callitem_shop_v2(point) {
      // this.$store.state.isLoading = true
      // var tappoint = point
      // console.log(tappoint)
      if (this.activeItem == 2) {
        point = this.menu_perpage
      }
      console.log(point)
      this.current_page_item = 0
      this.activeItem_item = 1
      console.log(this.obj_menus)
      console.log(this.obj_menus[point].items)
      this.obj_items = this.obj_menus[point].items
      this.activeMenu = this.obj_menus[point].cat_id
      console.log(this.obj_menus[0])
      // this.$store.state.isLoading = false
    },
    makeActive: function(item){
    	this.active = item;
    },
    openModal () {
      this.stage_modal = true
      $("#Modal").modal("show");
    },
    closeModal () {
      this.stage_modal = false
      $("#Modal").modal("hide");
    },
    reCalculatePrice () {
      console.log(this.item_cart)
      this.item_cart.forEach(element => {
        element.price = element.price_2 * element.qty
        element.price_slip = element.price_2
      })
    },
    onBarcodeScanned (barcode) {
      console.log(barcode)
      this.authMember(barcode)
    },
    authMember (barcode) {
      console.log("authMember:", barcode)
      if (barcode) {
        if (barcode == "memberpass1111") {
          this.member_type = 1
          this.$store.state.StatusQrcode = ''
          setTimeout(() => {
            this.stage_modal = false
            this.reCalculatePrice()
            this.callitem_shop()
            $("#Modal").modal("hide");
          }, 300)
        } else {
          this.CheckMemberC9(barcode)
        }
      }
    },
    CheckMemberC9(CodeID) {
      const header = {
        headers: {
          // "X-Access-Token": "12c1840ca3664dd799db80ce5f6a5b21"
          // "X-Access-Token": "5725a8c515594fcc81561169ba753087"
           "x-access-token": this.$store.state.accessToken
        }
      }
      const body = {
        code: CodeID
      }
      console.log(body)
      api.checkValidate(
        body,
        header,
        result => {
          this.$store.state.StatusQrcode = ''
          this.stage_modal = false
          $("#Modal").modal("hide")
          console.log(result)
          if (result.response == "available") {
            this.member_type = 1
            this.$store.state.memberProfile = result.data
            console.log("memberProfile:",this.$store.state.memberProfile)
            this.$store.state.flag_member = 1
            setTimeout(() => {
              this.reCalculatePrice()
              this.callitem_shop()
              $("#Modal").modal("hide");
            }, 300);
          } else {
            let text = ""
            let title = ""
            let text2 = ""
            let title2 = ""
            let ButtonText =""
            switch (this.lang) {
              case 0:
                text = "Member code not found Please contact staff"
                title = "Notification"
                ButtonText = "Close"
                break
              case 2:
                text = "找不到会员代码 请联系工作人员"
                title = "來自系統的通知"
                ButtonText = ""
                break
              default:
                text = "ไม่พบรหัสสมาชิก กรุณาติดต่อเจ้าหน้าที่"
                title = "แจ้งเตือนจากระบบ"
                ButtonText = "ปิด"
                break
            }
            Swal.fire({
                text: text,
                title: title,
                type: 'error',
                timer: 10000,
                confirmButtonText: ButtonText
              })
          }
        },
        error => {
          this.$store.state.StatusQrcode = ''
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  created(){
    if (!this.accessToken) {
      this.$router.push('/')
    } else {
      this.init_menus()
      // this.menucall()
      // console.log("this",this.accessToken)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.startsp()
    })    
    // window.addEventListener('window',
    // this.startsp(), false);
    // this.$socket.sendObj({
    //   command: 'edc_cancel'
    // })
  }
  // beforeDestroy () {
  //   this.$barcodeScanner.destroy()
  // }
}



// WEBPACK FOOTER //
// ./src/js/shopping.js